<template>
  <div>
    <header class="main-header isLogged">
      <RouterLink to="/">
        <img title="Dashboard" alt="Dashboard" src="/assets/img/LogoDoox.png" height="45" style="cursor: pointer">
      </RouterLink>
      <div class="header-actions">
        <!-- Componente de estado del token con opciones del header -->
        <TokenStatus 
          :opciones-header="opcionesHeader" 
          :mostrar-modal-acercade="mostrarModalAcercade"
          @toggle-modal-acercade="mostrarModalAcercade = !mostrarModalAcercade"
        />
        <!-- Modal Acercade -->
        <div v-if="mostrarModalAcercade" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.3);">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Acercade</h5>
                <button type="button" class="btn-close" @click="mostrarModalAcercade = false"></button>
              </div>
              <div class="modal-body" style="white-space: pre-line;">
                <pre style="font-family: 'Open Sans', sans-serif;"><strong>CON LICENCIA PARA:</strong>
Construcciones Portio S.A.
Calle Campogiro 25
39011 Peñacastillo
Santander
España

<strong>DATOS DEL SISTEMA:</strong>
Versión 2026 Actualizable

<strong>SOFTWARE DE TERCEROS:</strong>
Synology OS, Apache 2.4, MariaDB 11</pre>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" @click="mostrarModalAcercade = false">Cerrar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import {onMounted, ref} from "vue";
import axiosInstance from "@/axios";
import { useRoute } from "vue-router";
import TokenStatus from "./TokenStatus.vue";

export default {
  name: 'HeaderMenu',
  components: {
    TokenStatus
  },
  setup() {
    const opcionesHeader = ref([]);
    const route = useRoute();
    const mostrarModalAcercade = ref(false);

    // Realizamos la llamada al backend al cargar el componente
    onMounted(async () => {
      if(route.path !== '/login'){
        try {
          const response = await axiosInstance.get("/api/opcionesHeader");
          opcionesHeader.value = response.data;
        } catch (error) {
          console.error("Error al obtener los opcionesHeader", error);
        }
      }
    });

    return {
      opcionesHeader,
      mostrarModalAcercade,
    };
  },
}
</script>

<style scoped>

header.main-header {
  position: fixed;
  top: 0;
  height: 55px;
  background-color: #0d1e3f;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 15px;
  z-index: 999;
}

header.main-header .header-actions {
  display: flex;
  align-items: center;
}

header.main-header .header-actions > ul {
  display: none;
  list-style: none;
  padding: 0px;
  margin: 0px;
}

@media (min-width: 768px) {
  header.main-header .header-actions > ul {
    display: flex !important;
  }
}

header.main-header .header-actions > ul li {
  width: 50px;
  height: 50px;
  overflow: hidden;
  font-size: 23px;
  border-bottom: 4px solid #0d1e3f;
  margin-right: 10px;
}

header.main-header .header-actions > ul li.active {
  border-bottom: 4px solid #c3c3c3;
  background-color: #0d1e3f;
}

header.main-header .header-actions > ul li.active a {
  color: #fff !important;
}

header.main-header .header-actions > ul li a {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #fff;
}

header.main-header .header-actions > ul li a:hover {
  color: white;
}

header.main-header .header-actions > ul li.user {
  margin-right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

header.main-header .header-actions > ul li.user:hover .el-icon-user {
  color: white;
}

header.main-header .header-actions > ul li.user .el-icon-user {
  font-size: 23px;
  color: #fff;
}

header.main-header .header-actions > .el-dropdown {
  color: white;
  margin-right: 20px;
  top: 5px;
}

header.main-header .header-actions > .el-dropdown .el-icon-user {
  font-size: 1.6rem;
}

header.main-header .header-actions form .el-form-item {
  margin-bottom: 0px;
}

header.main-header .header-actions > button.mobile {
  border: 1px solid #ffffff4a;
  background-color: transparent;
  border-radius: 4px;
  padding: 1px 12px;
  font-size: 1.5rem;
  color: white;
  cursor: pointer;
}

header.main-header .header-actions .mobile {
  display: block;
}

@media (min-width: 768px) {
  header.main-header .header-actions .mobile {
    display: none !important;
  }
}

header.main-header > ul.menu-mobile {
  margin: 0px;
  padding: 0px;
  list-style: none;
  background-color: #373737;
  position: fixed;
  left: 0;
  right: 0;
  top: 55px;
  z-index: 2;
}

@media (min-width: 768px) {
  header.main-header > ul.menu-mobile {
    display: none !important;
  }
}

header.main-header > ul.menu-mobile > li {
  border-bottom: 1px solid #fff 12;
  display: flex;
  align-items: center;
  color: #fff;
  padding: 5px 30px;
  cursor: pointer;
}

header.main-header > ul.menu-mobile > li:last-child {
  border: 0px;
}

header.main-header > ul.menu-mobile > li > i {
  font-size: 1.4rem;
  margin-right: 15px;
}

header.main-header .menu-mobile-overlay {
  position: fixed;
  top: 55px;
  background-color: #0d1e3f;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

@media (min-width: 768px) {
  header.main-header .menu-mobile-overlay {
    display: none !important;
  }
}
</style>
